import React, { PropsWithChildren, useMemo } from 'react';
import { InstallmentsContextProvider } from './hooks/useProductInstallmentsList';
import pickInstallmentsList, { clusterInstallments } from '../modules/pickInstallments';
import { useCssHandles } from '../../../utils/functions';
import { seller } from '../../mock';

const CSS_HANDLES = ['installmentsListContainer'] as const;

interface Props {
	paymentSystemName?: string;
	installmentsToShow?: number[];
	/** Used to override default CSS handles */
	blockClass?: any;
	componentId?: string;
}

function InstallmentsList({
	paymentSystemName,
	installmentsToShow,
	blockClass,
	children,
	componentId,
}: PropsWithChildren<Props>) {
	const { handles }: any = useCssHandles(`vtex-product-price-1-x`, CSS_HANDLES, blockClass);
	const commercialOffer = seller?.commertialOffer;

	if (!commercialOffer?.Installments || commercialOffer.Installments?.length === 0) {
		return null;
	}

	let pickedInstallments: any = [];

	if (paymentSystemName) {
		const installmentsByPaymentSystem = clusterInstallments(commercialOffer.Installments, 'PaymentSystemName');

		if (!installmentsByPaymentSystem[paymentSystemName]) {
			return null;
		}

		pickedInstallments = installmentsByPaymentSystem[paymentSystemName];
	} else {
		pickedInstallments = pickInstallmentsList(commercialOffer.Installments, 'PaymentSystemName');
	}

	const filteredInstallments = installmentsToShow?.length
		? pickedInstallments.filter((option: any) => installmentsToShow.includes(option.NumberOfInstallments))
		: pickedInstallments;

	return (
		<div data-selection={componentId} className={handles.installmentsListContainer}>
			{filteredInstallments.map((inst: any, i: any) => {
				return (
					<InstallmentsItem installment={inst} key={i}>
						{children}
					</InstallmentsItem>
				);
			})}
		</div>
	);
}

interface ItemProps {
	installment: any;
}

function InstallmentsItem(props: PropsWithChildren<ItemProps>) {
	const { installment, children } = props;
	const contextValue = useMemo(() => ({ installment }), [installment]);

	return <InstallmentsContextProvider value={contextValue}>{children}</InstallmentsContextProvider>;
}

export default InstallmentsList;
